<template lang="pug">
  section
    b-container
      h1 Content
      b-nav
        b-nav-item(:to="{name: 'ContentFaq'}") FAQ
    b-container.pt-3
      router-view
</template>

<script>
import standardMix from '@/mixins/standardMix';
import { mapState } from 'vuex';

export default {
  mixins: [standardMix],
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('resource', ['faq_topics']),
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/Content.vue